import React, { useState, useContext } from "react";
import EnquiryPopup from "./EnquiryPopup";
import { ThemeContext } from "../context/ThemeContext";

const cities = [
  "Ahmedabad", "Aurangabad", "Bangalore", "Bhopal", "Bhubaneshwar", "Chandigarh",
  "Chennai", "Coimbatore", "Delhi", "Hyderabad", "Jaipur", "Jammu", "Kochi",
  "Kolkata", "Lucknow", "Madurai", "Mangalore", "Mumbai", "Nagpur", "Patna",
  "Pune", "Raipur", "Vadodara", "Visakhapatnam", "Other"
];

const comboPackages = [
  "Dubai Holiday Packages",
  "Thailand Holiday Packages",
  "Maldives Holiday Packages",
  "Bali Holiday Packages",
  "Singapore Holiday Packages",
  "Sri Lanka Holiday Packages",
  "Malaysia Holiday Packages",
  "Vietnam Holiday Packages"
];

const PopularPackageLinks = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("");
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  const handleCardClick = (title) => {
    setSelectedTitle(title);
    setIsPopupOpen(true);
  };

  return (
    <section className={`${isDark ? "dark" : ""}`}>
      <div className="w-full mx-auto px-4 py-12 bg-gray-100 dark:bg-gray-900 transition-colors duration-300">
        <EnquiryPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          prefill={{ destination: selectedTitle }}
        />

        {/* City Based Packages */}
        <div className="mb-10">
          <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
            Packages from Departure City
          </h2>
          <div className="flex flex-wrap gap-3">
            {cities.map((city, index) => (
              <button
                key={index}
                onClick={() =>
                  handleCardClick(`International Tour Packages from ${city}`)
                }
                className="inline-block px-4 py-2 text-sm bg-white border border-gray-300 rounded-full hover:bg-gray-100 transition-all text-gray-800 
                dark:bg-gray-150 dark:text-gray-800 dark:hover:bg-gray-200"
              >
                International Holiday Packages from {city}
              </button>
            ))}
          </div>
        </div>

        {/* Combo Packages */}
        <div>
          <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
            Combo Packages
          </h2>
          <div className="flex flex-wrap gap-3">
            {comboPackages.map((pkg, index) => (
              <button
                key={index}
                onClick={() => handleCardClick(pkg)}
                className="inline-block px-4 py-2 text-sm bg-white border border-gray-300 rounded-full hover:bg-gray-100 transition-all text-gray-800 
                dark:bg-gray-150 dark:text-gray-800 dark:hover:bg-gray-200"
              >
                {pkg}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularPackageLinks;
